import { render, staticRenderFns } from "./tableApprovalTes.vue?vue&type=template&id=1d5f9414&scoped=true"
import script from "./tableApprovalTes.vue?vue&type=script&lang=js"
export * from "./tableApprovalTes.vue?vue&type=script&lang=js"
import style0 from "./tableApprovalTes.vue?vue&type=style&index=0&id=1d5f9414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f9414",
  null
  
)

export default component.exports